//import { createApp, onMounted, onBeforeUnmount } from 'vue'
import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from "./routers"
import JsonExcel from "vue-json-excel3"
import VueExcelXlsx from "vue-excel-xlsx"
import VueCookies from 'vue-cookies'
import axios from 'axios'
import keycloak from './service/keycloak'


import './style/style.css';    




loadFonts()

//FOR MULTILANGUAGE
import { createI18n } from 'vue-i18n'
import en from './lang/translations/en.json'
import fr from './lang/translations/fr.json'

const messages = {
  en,
  fr
}

const i18n = new createI18n({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

i18n.locale = 'fr'

if (module.hot) {
  module.hot.accept(['./lang/translations/en.json', './lang/translations/fr.json'], function () {
    i18n.setLocaleMessage('en', require('./lang/translations/en.json').default)
    i18n.setLocaleMessage('fr', require('./lang/translations/fr.json').default)
  })
}

//END FOR MULTILANGUAGE

const app = createApp(App);

//declare global variable
window.baseurl = process.env.VUE_APP_BASE_URL;
window.baseurl2 = process.env.VUE_APP_BASE_URL_V2;
// window.baseurl = "http://localhost:8080/api/v1/"
// window.baseurl_2 = "http://localhost:8182/api/"

app.config.globalProperties.waiting_time = 1000; 
app.config.globalProperties.featureFlags = [];




//global function for logout
app.config.globalProperties.logout = function(){
  localStorage.clear();
  keycloak.logout()  //redirect to keycloack login page
}


//global function to check token validity
app.config.globalProperties.checkTokenExpiry = function() { 
  refreshAccessToken()
}





//const app = createApp(App);

     function getuserDetails1 () {
      axios.get(window.baseurl +"customers/name/" + keycloak.tokenParsed.email , { "headers": {'Authorization': 'Bearer ' + keycloak.token} })
      .then((res) => {
        // console.log("passed", res)

        localStorage.setItem("user-login-status", res.data.status);   
        
        app.config.globalProperties.userId = res.data.id;        
        app.config.globalProperties.userStatus = res.data.status;
        app.config.globalProperties.orgId = res.data.organization.id;
        app.config.globalProperties.orgName = res.data.organization.orgName;
        
        if(res.data.organization.status){
          if(app.config.globalProperties.userStatus){ 
            getFeatureFlag(res.data.organization.id)           
            app.mount("#app");
          }else{
            keycloak.logout();
          }
        }else{
          keycloak.logout();
        }
  
       
        
      })
      .catch((error) => {        
        console.log("failed", error)
        // this.$root.vtoast.showError({ message: error });
        keycloak.logout();           
      })
  }  

    //get featureFlags   control barcode and dual currency
   function getFeatureFlag (id) {
      //console.log("passed", id)
      axios.get(window.baseurl +"featureFlags/enabled/" + id , { "headers": {'Authorization': 'Bearer ' + keycloak.token} })
      .then((res) => {
        console.log("passed", res)        
        app.config.globalProperties.featureFlags = res.data.features; 
        //console.log("passed1", app.config.globalProperties.featureFlags)   
  
      })
      .catch((error) => {        
        console.log("getFeatureFlag failed", error)            
      })
  } 
  
  
  


  //refresh token
  function refreshAccessToken(){  
    try{
      keycloak.updateToken(120) //Adjust the refresh time as needed      
      localStorage.setItem("accessToken", keycloak.token);
      app.config.globalProperties.accessToken = keycloak.token
    }catch (error){
      // console.error("Token refresh error")
      this.$root.vtoast.showError({ message: "Token refresh error" });
    }
  }


  
  app
  .use(vuetify)
  .use(router)
  .use(i18n) 
  .use(VueCookies)  
  .use(VueExcelXlsx)
  .component("downloadExcel", JsonExcel)  
  //.mount('#app')


  

  keycloak.init({ 
    onLoad: "login-required" ,    
    checkLoginIframe: false,    
  })
  .then(auth => {    
    if (!auth) {          
      window.location.reload();      
    } else {   
      // console.error("Authenticated ");
      //app.provide('$keycloak', keycloak);  // Provide Keycloak instance globally
      app.config.globalProperties.$keycloak = keycloak;  // Provide Keycloak instance globally
      //app.mount("#app");     

      app.config.globalProperties.accessToken = keycloak.token    
      app.config.globalProperties.userName =  keycloak.tokenParsed.preferred_username
      app.config.globalProperties.userEmail =  keycloak.tokenParsed.email
      app.config.globalProperties.global_permissions = keycloak.tokenParsed.roles
      app.config.globalProperties.name =  keycloak.tokenParsed.name
      //console.log("permissions", keycloak);
      //get user details 

      if(keycloak.tokenParsed.roles.includes("ROLE_STAFF_ADMIN")||keycloak.tokenParsed.roles.includes("ROLE_STAFF_USER") ){
          app.mount("#app");
      }else{
           getuserDetails1()
      }
      

      
    }
    //Token Refresh
    setInterval(() => {
      keycloak.updateToken(70).catch(() => {
        // console.error("Failed to refresh token");
        this.$root.vtoast.showError({ message: "Failed to refresh token" });
      });
    }, 6000); 
  })
  .catch(e => {
    console.error("Authenticated Failed " + e);
    // this.$root.vtoast.showError({ message: "Authenticated Failed " + e });
    keycloak.logout()    //logout if authentication failed
  });


  


  


  

  





  
